/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostAccountSettingsItemMediaInformation
 */
export interface PostAccountSettingsItemMediaInformation {
    /**
     * メディア名
     * @type {string}
     * @memberof PostAccountSettingsItemMediaInformation
     */
    mediaName?: string | null;
    /**
     * メディアURL
     * @type {string}
     * @memberof PostAccountSettingsItemMediaInformation
     */
    mediaUrl?: string | null;
    /**
     * メディアタイプ
     * @type {string}
     * @memberof PostAccountSettingsItemMediaInformation
     */
    mediaType?: PostAccountSettingsItemMediaInformationMediaTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum PostAccountSettingsItemMediaInformationMediaTypeEnum {
    _001 = '001',
    _002 = '002',
    _003 = '003',
    _004 = '004',
    _005 = '005',
    _006 = '006',
    _008 = '008'
}

export function PostAccountSettingsItemMediaInformationFromJSON(json: any): PostAccountSettingsItemMediaInformation {
    return PostAccountSettingsItemMediaInformationFromJSONTyped(json, false);
}

export function PostAccountSettingsItemMediaInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAccountSettingsItemMediaInformation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaName': !exists(json, 'media_name') ? undefined : json['media_name'],
        'mediaUrl': !exists(json, 'media_url') ? undefined : json['media_url'],
        'mediaType': !exists(json, 'media_type') ? undefined : json['media_type'],
    };
}

export function PostAccountSettingsItemMediaInformationToJSON(value?: PostAccountSettingsItemMediaInformation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_name': value.mediaName,
        'media_url': value.mediaUrl,
        'media_type': value.mediaType,
    };
}

